<div class="modal-header">
  <h4 class="modal-title">
    {{ (isEditMode ? 'ReservationFiles.EditCloudLink' : 'ReservationFiles.AddCloudLink') | translate }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="form-group">
      <label for="link-url">{{ 'ReservationFiles.LinkUrl' | translate }} *</label>
      <input
        id="link-url"
        type="url"
        class="form-control"
        formControlName="url"
        placeholder="https://..."
        autocomplete="off"
      />
      <div class="text-danger small mt-1" *ngIf="form.get('url').touched && form.get('url').errors?.required">
        {{ 'ReservationFiles.LinkUrlRequired' | translate }}
      </div>
      <div class="text-danger small mt-1" *ngIf="form.get('url').touched && form.get('url').errors?.invalidUrl">
        {{ 'ReservationFiles.LinkUrlInvalid' | translate }}
      </div>
      <div class="text-muted small mt-1" *ngIf="providerName">{{ providerName }}</div>
    </div>
    <div class="form-group">
      <label for="link-name">{{ 'ReservationFiles.Label' | translate }} *</label>
      <input id="link-name" type="text" class="form-control" formControlName="fileName" autocomplete="off" />
      <div class="text-danger small mt-1" *ngIf="form.get('fileName').touched && form.get('fileName').errors?.required">
        {{ 'ReservationFiles.LabelRequired' | translate }}
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss('')">
    {{ 'Common.Abort' | translate }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="saving || form.invalid" (click)="save()">
    {{ 'ReservationFiles.Save' | translate }}
  </button>
</div>
